<form clrForm [formGroup]="editMaterialForm">
	<ng-container *ngIf="material">
		<table class="table" id="materialTable">
			<thead>
			<tr>
				<th class="left">Material</th>
				<th class="left">Werkstoffbezeichnung</th>
				<th class="left">Werkstoffnummer</th>
				<th class="left">Wärmebehandlungszustand</th>
				<th class="left">Beschreibung</th>
				<th class="left">Alternative</th>
				<th class="left">Datenblatt</th>
				<th>Aktion</th>
			</tr>
			</thead>
			<tbody>
			<tr>
				<td class="left"><input type="text" formControlName="material" class="clr-input" placeholder="Material"></td>
				<td class="left"><input type="text" formControlName="werkstoffbezeichnung" class="clr-input" placeholder="Werkstoffbezeichnung"></td>
				<td class="left"><input type="text" formControlName="werkstoffnummer" class="clr-input" placeholder="Werkstoffnummer"></td>
				<td class="left"><input type="text" formControlName="waermebehandlungszustand" class="clr-input" placeholder="Wärmebehandlungszustand"></td>
				<td class="left"><input type="text" formControlName="description" class="clr-input" placeholder="Beschreibung"></td>
				<td class="left"><input type="number" formControlName="alternative" class="clr-input" placeholder="Alternative"></td>
				<td class="left">
					<div *ngIf="datenblaetter.length === 0">Keine Datenblaetter</div>
					<div *ngFor="let file of datenblaetter">
						<clr-tooltip>
							<button class="btn btn-sm btn-link" clrTooltipTrigger (click)="openPdf(file)" aria-label="Datenblatt anzeigen">
								<cds-icon shape="pdf-file" size="20" aria-hidden="true"></cds-icon>
							</button>
							<clr-tooltip-content [clrPosition]="'top-right'" [clrSize]="'sm'">
								{{ file.fileName || file.id }}
							</clr-tooltip-content>
						</clr-tooltip>
						<button class="btn btn-sm btn-danger" (click)="removeDatenblatt(file)" aria-label="Datenblatt entfernen" title="Entfernen">
							<cds-icon shape="trash" aria-hidden="true"></cds-icon>
						</button>
					</div>
				</td>
				<td class="btn-group btn-primary btn-icon center">
					<button class="btn btn-sm" (click)="updateMaterial()" [disabled]="editMaterialForm.invalid">
						<cds-icon shape="floppy"></cds-icon>
						<span class="clr-icon-title">Speichern</span>
					</button>
				</td>
			</tr>
			<tr>
				<td class="left" colspan="8">
					<app-upload
						[companyId]="0"
						[componentId]="''"
						[materialId]="editMaterialForm.get('material_id')?.value || 0"
						[projectId]="'0'"
						[jobId]="0"
						[subId]="0"
						[docType]="71"
						(uploadedFile)="handleUploadSuccess($event)">
					</app-upload>
				</td>
			</tr>
			</tbody>
		</table>
	</ng-container>
</form>

<br />
<a class="btn btn-warning-outline btn-sm" (click)="cancelEdit()">Abbrechen</a>

<clr-modal *ngIf="showPDF" id="pdfViewer" [(clrModalOpen)]="showPDF" [clrModalStaticBackdrop]="false" [clrModalSize]="modalSize">
	<h3 class="modal-title">{{ modalContent }}</h3>
	<div class="modal-body">
		<ngx-extended-pdf-viewer [src]="modalUrl" useBrowserLocale="true" height="85vh" [textLayer]="true"></ngx-extended-pdf-viewer>
	</div>
</clr-modal>
